export const SKILLS_DRAWER_ID = 'skills-drawer'
